(function ($) {
  var root = $('html, body');

  $('.page-menu a[href^="#"]').click(function () {
    const isMobile = window.matchMedia('(min-width: 48em)').matches;
    const offset = isMobile ? 190 : 150;
    var id = $(this).attr('href').replace('#', '');

    root.animate(
      {
        scrollTop: $($.attr(this, 'href')).offset().top - offset,
      },
      500
    );
    $('#' + id).focus();

    return false;
  });

  var pageSelector = document.querySelectorAll('.page-menu-selector');

  for (var i = 0; i < pageSelector.length; i++) {
    var pageMenus = pageSelector[i];

    pageMenus.addEventListener('click', function () {
      var menu = this.nextElementSibling;
      if (menu.classList.contains('open')) {
        menu.classList.remove('open');
      } else {
        menu.classList.add('open');
      }
    });
  }
})(window.jQuery);
